// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"buttonStyles_buttonWrapper__qaq2w","button":"buttonStyles_button__fmNff","active":"buttonStyles_active__RJMRr"};